/**
 * Zentrale Zahlenformatierung für die Oberfläche (de-DE: Dezimal-Komma,
 * Tausender-Punkt). EINZIGE Stelle für Anzeige-Zahlen — kein `toFixed()`
 * mehr in Komponenten, damit Karten, Panels, Tabellen und Charts dieselbe
 * Sprache sprechen (UI-Audit C1).
 *
 * Nicht für maschinenlesbare Ausgaben (CSV/JSON/CSS-Werte) verwenden —
 * dort bleibt der Dezimalpunkt Pflicht.
 */

const cache = new Map<number, Intl.NumberFormat>();

const formatter = (digits: number): Intl.NumberFormat => {
  let f = cache.get(digits);
  if (!f) {
    f = new Intl.NumberFormat('de-DE', { minimumFractionDigits: digits, maximumFractionDigits: digits });
    cache.set(digits, f);
  }
  return f;
};

/** Zahl mit fixer Nachkommastellenzahl im deutschen Format, z. B. fmt(1234.5, 1) → "1.234,5". */
export const fmt = (value: number, digits = 2): string => {
  if (!Number.isFinite(value)) return String(value);
  // Vermeidet "-0,00" bei winzigen negativen Werten.
  const rounded = Number(value.toFixed(digits));
  return formatter(digits).format(Object.is(rounded, -0) ? 0 : rounded);
};

/** Wie fmt, aber null/undefined/NaN werden zu undefined durchgereicht (`fmtOpt(x, 1) ?? '–'`). */
export const fmtOpt = (value: number | null | undefined, digits = 2): string | undefined =>
  value == null || Number.isNaN(value) ? undefined : fmt(value, digits);

/** Ganze Zahl mit Tausenderpunkt, z. B. fmtInt(15439) → "15.439". */
export const fmtInt = (value: number): string => fmt(value, 0);
